define("shared/components/shared/media-items/modal-display", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Image
    @picture={{hash sources=@mediaItem.largeDisplayUrl}}
    alt={{@mediaItem.defaultCaption}}
    class="o--modal__media"
  />
  
  {{! Note: IF not yet approved by the owner of the original media, request to use image already sent }}
  {{#if @mediaItem.needsApproval}}
    <span class="o--mediaOverlay">
      <span class="img--overlay__pending"></span>
    </span>
  {{/if}}
  */
  {
    "id": "C+H5M9QX",
    "block": "[[[8,[39,0],[[16,\"alt\",[30,1,[\"defaultCaption\"]]],[24,0,\"o--modal__media\"]],[[\"@picture\"],[[28,[37,1],null,[[\"sources\"],[[30,1,[\"largeDisplayUrl\"]]]]]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"needsApproval\"]],[[[1,\"  \"],[10,1],[14,0,\"o--mediaOverlay\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"img--overlay__pending\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@mediaItem\"],false,[\"shared/image\",\"hash\",\"if\"]]",
    "moduleName": "shared/components/shared/media-items/modal-display.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});